export const isMobileResolution = window.innerWidth <= 480;
